import { createContext } from 'react';

type Param = () => boolean;
export const OverflowContext = createContext<Set<Param> | undefined>(undefined);
